<ion-header>
  <ion-toolbar>
    <ion-title class="toolbar-title-center">
      <img src="assets/icon/sravyaa.png" alt="Sravyaa" class="toolbar-logo-center" />
    </ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="onThemeToggle(!isDarkMode)" aria-label="Toggle theme">
        <ion-icon slot="icon-only" [name]="isDarkMode ? 'sunny-outline' : 'moon-outline'"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding home-container">
  <!-- Scanner Container -->
  <div class="scanner-box" (click)="chooseScan()">
    <video
      *ngIf="mode === 'scan' && scanning"
      id="video-preview"
      autoplay
      muted
      playsinline
      style="width: 100%; height: 100%; object-fit: cover; border-radius: 12px;"
    ></video>

    <div *ngIf="!(mode === 'scan' && scanning)" class="scanner-placeholder">
      <img src="assets/icon/sravyaa.png" alt="Sravyaa" class="scanner-logo" />
     <!--<ion-icon name="qr-code-outline" style="font-size: 3rem; color: var(--ion-text-color);"></ion-icon>--> 
      <div class="scanner-text">Click here to Scan QR</div>
    </div>
  </div>

  <!-- Stop Scan Button -->
  <ion-button *ngIf="scanning" expand="block" color="danger" (click)="stopScan()">Stop Scanning</ion-button>

  <!-- Manual Code Input -->
  OR
  <div>
    <ion-item class="manualCodeInput">
      <ion-input
        [(ngModel)]="manualCode"
        placeholder="Enter Code"
        label="Enter Code Manually"
        labelPlacement="stacked"
        clearInput>
      </ion-input>
    </ion-item>
    <ion-button expand="block" style="color: black; --background: var(--ion-color-primary);" (click)="handleManualCode()" [disabled]="!manualCode">
      Submit Code
    </ion-button>
  </div>

  <h1 class="title">Welcome to <strong>Sravyaa</strong></h1>
  <p class="subtitle">Scan, explore and get info</p>
</ion-content>
